import React from 'react';
import Button from '@mui/material/Button';
import { joinDefined, stringIsNullOrEmpty } from '../../utils/strings';
import history from '../../utils/history';
import { IconButton } from '@mui/material';
import { DeleteIcon } from '../IconIndex';

/**
 * Primary coloured button
 * variants:
 	primary
	secondary
	tertiary
 	quaternary
 	urgent
	confirmation
	modal-action
	tag
 */
const ButtonWrapper = ({
    classes,
    onClick,
    children,
    className,
    color,
    href,
    size,
    icon,
    startIcon,
    endIcon,
    target,
    title,
    variant = 'primary',
    ...props
}) => {
    const variants = variant.split(' ');
    const sizeCss = !stringIsNullOrEmpty(size) ? `button-base--${size}` : null;
    if (target) {
        title = joinDefined([title, '(Opens in a new window)'], ' ');
    }
    const onClickEvent = e => {
        if (e && href) {
            e.preventDefault();
        }
        if (!e.key || ['Enter', ' '].includes(e.key)) {
            if (onClick) return onClick(e);
            else if (target) return window.open(href, target);
            return history.push(href);
        }
    };

    if (variant.includes('link')) {
        return (
            <a
                {...props}
                href={href}
                target={target || undefined}
                onClick={onClickEvent}
                title={title}
                className={`button-base ${variant} ${sizeCss || ''} ${!!target ? 'targetNewPage' : ''}`}
            >
                {props.text || children}
            </a>
        );
    }

    if (variants.indexOf('tag') > -1) {
        const { disabled } = props;
        return (
            <div className={`button-base ${variant} ${sizeCss || ''} ${disabled ? 'disabled' : ''}`}>
                <span className="button-label">{children}</span>
                {onClick && (
                    <span
                        style={disabled ? { opacity: 0.25 } : null}
                        onClick={!disabled ? onClickEvent : null}
                        onKeyDown={!disabled ? onClickEvent : null}
                        role="button"
                        tabIndex="0"
                        className={`icon-button ${variant}`}
                        title="Remove"
                    >
                        <DeleteIcon />
                    </span>
                )}
            </div>
        );
    }
    if (icon && !children) {
        return (
            <IconButton
                variant="contained"
                color="primary"
                onClick={onClickEvent}
                className={`button-base icon-button ${joinDefined([variant, sizeCss], ' ')}`}
                title={title}
                {...props} size="large">
                <span className={`button-label ${!!target ? 'targetNewPage' : ''}`}>
                    {icon}
                </span>
            </IconButton>
        );
    }

    return (
        <Button
            variant="contained"
            color="primary"
            onClick={onClickEvent}
            className={`button-base ${joinDefined([variant, sizeCss], ' ')}`}
            title={title}
            {...props}
        >
            <span className={`button-label ${!!target ? 'targetNewPage' : ''}`}>
                {(icon || startIcon || endIcon) ? <>{icon || startIcon}<span
                    className="button-txt">{children}</span>{endIcon}</> : children}
            </span>
        </Button>
    );
};

export default ButtonWrapper;
